import { connect } from 'react-redux'

import {
  getSkipRecoveryContent,
  modalVisibilityChange,
  trackViewDiscountReminder,
  keepOrder,
  cancelOrder
} from 'actions/onScreenRecovery'
import { actionTypes } from 'actions/actionTypes'
import { OrderSkipOSRView } from './OrderSkipOSRView'

const mapStateToProps = (state) => ({
  triggered: state.onScreenRecovery.getIn(['orderSkip', 'triggered']),
  title: state.onScreenRecovery.getIn(['orderSkip', 'title']),
  offers: state.onScreenRecovery.getIn(['orderSkip', 'offers']),
  promoCode: state.onScreenRecovery.getIn(['orderSkip', 'promoCode']),
  offer: state.onScreenRecovery.getIn(['orderSkip', 'offer']) && state.onScreenRecovery.getIn(['orderSkip', 'offer']).toJS(),
  modalType: state.onScreenRecovery.getIn(['orderSkip', 'modalType']),
  isFetching: state.pending.get(actionTypes.ORDER_SKIP_RECOVERY_TRIGGERED),
})

const mapDispatchToProps = {
  onKeep: keepOrder,
  onConfirm: cancelOrder,
  modalVisibilityChange,
  getSkipRecoveryContent,
  trackViewDiscountReminder
}

export const OrderSkipOSRViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderSkipOSRView)
